import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { get, isEmpty } from 'lodash'
import { useDispatch } from 'react-redux';
import { addQuestion, modalToggle, stateValues } from '../slices/predictionSlice';
import axios from 'axios';
import { apiBaseUrl } from '../configs/configs';
import Swal from 'sweetalert2'
import { getQuestions } from '../slices/apiCalling';
import Style from './prediction.module.css'
import { withRouter } from 'react-router-dom';
import moment from 'moment'

function PredictionQuestion({ match_id, series_id, isSubjective, history }) {
    const predictionState = useSelector(state => state.prediction)
    const dispatch = useDispatch()
    const [imagePQ, setImagePQ] = useState(undefined)
    const setOption = (e, index) => {
        let option = [...predictionState.questionStates.option]
        const data = {
            option: e.target.value,
            isCorrect: false,
            id: index + 1
        }
        option[index] = data
        dispatch(stateValues({ name: 'option', value: option }))
    }

    const addOptionFiled = () => {
        if (!isEmpty(predictionState.questionStates.question_english)) {
            dispatch(stateValues({ name: 'option', value: [...predictionState.questionStates.option, { option: '', isCorrect: false }] }))
        } else {
            alert('fill question field')
        }
    }

    const selectCorrectAnswer = (e) => {
        const option = predictionState.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    const onChangeInputText = (e) => {
        const { name, value } = e.target
        dispatch(stateValues({ name, value }))
    }
    const setQuestionImage = (e) => {
        const file = e.target.files[0]
        setImagePQ(file)
    }

    const removeOption = (index) => {
        const options = predictionState.questionStates.option.filter((data, i) => i !== index)
        dispatch(stateValues({ name: 'option', value: options }))
    }

    const toggle = () => {
        dispatch(modalToggle())
    }

    const submit = async () => {
        if (isValidate()) {
            const result = await Swal.fire({
                title: 'Do you want to save the changes?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            })
            if (result.isConfirmed) {
                await submitQuestion()
            }
        }
    }

    const submitQuestion = async () => {
        const formData = new FormData();
        let data = {
            ...predictionState.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(predictionState.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(predictionState.questionStates.predic_end_time).utc().format(),
        }
        formData.append('image', imagePQ);
        if (isSubjective) {
            data = { ...data, is_subjective: true }
        }
        formData.append('data', JSON.stringify(data));
        const result = await axios.post(`${apiBaseUrl}/prediction/match/${match_id}/series/${series_id}`, formData)
        if (result.data.status === 'success') {
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Question Successfully Added',
                showConfirmButton: false,
                timer: 1500
            })
            await getQuestions(match_id, series_id, dispatch, addQuestion)
            toggle()
        }
    }

    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const isValidate = () => {
        let status = true
        const data = predictionState.questionStates
        if (!isEmpty(data.inputAnswerNumber) || data.option.some(data => data.isCorrect)) {
            status = true
        }
        else {
            if (isEmpty(data.question_english)) {
                status = false
                getSweetAlert('error', 'enter the question')
            }
            else if (data.entry_fee <= 0) {
                status = false
                getSweetAlert('error', 'enter the entry fee')
            }
            else if (isEmpty(data.predic_start_time)) {
                status = false
                getSweetAlert('error', 'Start Time Must Be More Than Present Time')

            }
            else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
                status = false
                getSweetAlert('error', 'End Time Must be Larger Than Start Time')
            }
            else if (!predictionState.isSubjective && (data.option.some(data => isEmpty(data.option)) || data.option.length < 2)) {
                status = false
                getSweetAlert('error', 'fill the all option field and minimum 2 option field required')

            }
            else if (predictionState.isSubjective && data.slots_per_user > 2) {
                status = false
                getSweetAlert('error', 'For Subject User Slot Not More Than 2')
            } else if (!predictionState.isSubjective && data.slots_per_user > 1000) {
                status = false
                getSweetAlert('error', 'For Subject User Slot Not More Than 1000')
            }
            else if (predictionState.isSubjective && data.slots > 100) {
                status = false
                getSweetAlert('error', 'For Subject Slot Not More Than 100')
            }
            else if (!predictionState.isSubjective && data.slots > 100000) {
                status = false
                getSweetAlert('error', 'For Subject Slot Not More Than 100000')
            }
            else if (Number(data.slots_per_user) >= Number(data.slots)) {
                console.log(">>>goes here");
                status = false
                getSweetAlert('error', 'User Slot Not More Than Total Slots')
            }
            else if (Number(data.admin_commission) < 10) {
                status = false
                getSweetAlert('error', 'Admin Commission Not Less Than 10')
            }
        }
        return status
    }
    return (
        <Modal isOpen={predictionState.modal_show} toggle={toggle} centered={true} backdrop={"static"}>
            <ModalHeader toggle={toggle}>Add Question</ModalHeader>
            <ModalBody>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ width: '30%' }}>
                        <p style={{ margin: 0 }}>Entry Fee</p>
                        <Input placeholder='Entry Fee' type='number' name='entry_fee' onChange={(e) => e.target.value > 0 && setQuestion(e)} value={predictionState.questionStates.entry_fee} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                    </div>
                    <div style={{ width: '30%' }}>
                        <p style={{ margin: 0 }}>Total Slots</p>
                        <Input placeholder='Slots' type='number' name='slots' onChange={(e) => e.target.value > 0 && setQuestion(e)} value={predictionState.questionStates.slots} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                    </div>
                    <div style={{ width: '30%' }}>
                        <p style={{ margin: 0 }}>Slots Per User</p>
                        <Input placeholder='slots per user' type='number' name='slots_per_user' onChange={(e) => e.target.value > 0 && setQuestion(e)} value={predictionState.questionStates.slots_per_user} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                    </div>
                    <div style={{ width: '40%' }}>
                        <p style={{ margin: 0 }}>Admin Commission</p>
                        <Input placeholder='Admin Commission' type='number' name='admin_commission' onChange={setQuestion} value={predictionState.questionStates.admin_commission} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                    </div>
                </div>
                <div className={Style.date_time_picker_container}>
                    <div>
                        <p>Start Date and Time</p>
                        <Input type='datetime-local' name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                    </div>
                    <div>
                        <p>End Date and Time</p>
                        <Input type='datetime-local' name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : !get(predictionState, "questionStates.status")} />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 10px' }}>
                    <div>
                        <Input id='pred_confirm' checked={JSON.parse(predictionState.questionStates.pred_confirm)} value={!JSON.parse(predictionState.questionStates.pred_confirm)} type='checkbox' placeholder='Entry Fee' name='pred_confirm' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} ></Input>
                        <Label for={'pred_confirm'} style={{ padding: 0 }}>Prediction Confirm</Label>
                    </div>
                    <div>
                        <Input id='pred_autocreate' checked={JSON.parse(predictionState.questionStates.pred_autocreate)} type='checkbox' name='pred_autocreate' onChange={setQuestion} value={!JSON.parse(predictionState.questionStates.pred_autocreate)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                        <Label for={'pred_autocreate'} style={{ padding: 0 }}>Prediction Autocreate</Label>
                    </div>
                </div>
                <Input id='question' name='question_english' value={predictionState.questionStates.question_english} onChange={setQuestion} placeholder='write question in english ?' style={{ margin: '10px 5px' }} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                <Input value={predictionState.questionStates.question_hindi} name='question_hindi' onChange={setQuestion} placeholder='सवाल हिंदी में लिखें ?' style={{ margin: '10px 5px' }} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                {predictionState.questionStates.option.map((data, index) => <div key={index} style={{ display: 'flex', alignItems: 'center' }}><Input placeholder={`option ${index + 1}`} value={data.option} style={{ margin: '10px 5px' }} onChange={(e) => setOption(e, index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input> <Button style={{ background: '#e62828e6', color: '#fff', border: 'none' }} onClick={() => removeOption(index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Delete</Button></div>)}
                {predictionState.questionStates.option.length < 4 && !isSubjective && <Button style={{ display: 'block', margin: '10px auto' }} onClick={addOptionFiled} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Add Options</Button>}
                {isSubjective ? <Input style={{ margin: '10px' }} type='number'
                    name='inputAnswerNumber' value={predictionState.questionStates.inputAnswerNumber} onChange={onChangeInputText} placeholder="Input Number" disabled={get(predictionState, "questionStates.status")} />
                    : <Input style={{ margin: '10px' }} type='select' value={get(predictionState.questionStates.option.find(data => data.isCorrect), 'id', '')} disabled={get(predictionState, "questionStates.status")} onChange={selectCorrectAnswer}>
                        <option>Select Answer</option>
                        {predictionState.questionStates.option.map((data, index) =>
                            <option value={data.id} key={index}>{data.option}</option>
                        )}
                    </Input>}
                <div>
                    <Input type="file" accept='image/*' name={'image'} onChange={setQuestionImage} />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={submit}>Submit</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    )

}
export default withRouter(PredictionQuestion)